import { ChartView, CUSTOM_UNITS } from './chartModel'
import { round } from 'lodash'
import { ValueType } from 'recharts/types/component/DefaultTooltipContent'
import { ActivePayload } from '../types'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'
import { stringWithSIPrefix, STATISTICS_SI_PREFIXES } from 'src/Libs/system-data-handler/utils/formatNumberWithSIPrefix'
import { UnitTypes } from 'src/Libs/types'

/**
 * format chart value based on unit
 * @param value
 * @param unit
 * @returns formatted value string
 */
export const formatValue = (value: number | undefined | null, unit: string): string => {
  if (!value) {
    return '-'
  }

  if (!CUSTOM_UNITS.includes(unit)) {
    return stringWithSIPrefix(value, unit, 1, undefined, STATISTICS_SI_PREFIXES)
  } else {
    return `${Math.round(value)} ${unit}`
  }
}

const formatTraceValueType = (value: ValueType | undefined, trace: string, useOriginalValue: boolean): number | undefined => {
  if (useOriginalValue) {
    return value as number
  }

  if (trace === 'ASOC') {
    return round(value as number)
  } else {
    return round(value as number, 2)
  }
}

/**
 * This function provide the value of the trace with the correct unit depending on the chart view
 */
export const formatLegendValue = (hoverPayload: ActivePayload, defaultUnit: string, view: ChartView): string => {
  const isCustomUnit = CUSTOM_UNITS.includes(hoverPayload.unit)
  const useOriginalValue = typeof hoverPayload.value !== 'number' || hoverPayload.value === 0
  const valueToUse = formatTraceValueType(hoverPayload.value, hoverPayload.dataKey, useOriginalValue) as number
  const fallbackUnit = view === 'day' ? UnitTypes.watt : UnitTypes.wattHour

  if (!valueToUse) {
    return '-'
  }

  const normalizedValue = round(valueToUse)
  const localizedValue = getLocalizedNumber(hoverPayload.dataKey === 'ASOC' || hoverPayload.dataKey === 'f-ASOC' ? valueToUse : normalizedValue)

  if (isCustomUnit) {
    return `${localizedValue} ${hoverPayload.unit ?? defaultUnit}`
  }

  return stringWithSIPrefix(valueToUse, fallbackUnit, 1, undefined, STATISTICS_SI_PREFIXES)
}

export const getHoverValueWithcorrectUnit = (
  activePayload: ActivePayload[] | undefined,
  key: string,
  unit: string,
  showForecast: boolean,
  view: ChartView
): string | undefined => {
  const item = activePayload?.find((item: ActivePayload) => item.dataKey === key)
  if (!item) return undefined

  const forecastItem = activePayload?.find((item: ActivePayload) => item.dataKey.substring(2) === key)
  const itemToUse = showForecast && forecastItem?.value ? forecastItem : item

  return formatLegendValue(itemToUse, unit!, view)
}
